import { render, staticRenderFns } from "./AdminCallback.vue?vue&type=template&id=79dfbbc0&"
import script from "./AdminCallback.vue?vue&type=script&lang=js&"
export * from "./AdminCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports